import { useDataChange } from 'Simple/Data'

export function useOnClearAppointmentTypes(props) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'selected.sidebar_appointment_templates',
  })

  return function onClick() {
    change([])
  }
}
